import CommonModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import alert_icon from "../../../asset/image/alert_icon.svg";

interface AssignConfigDialogProps {
    assignConfigOpen: boolean;
    assignedConfig: any;
    handleAssignConfigClose: () => void;
    handleAssignConfigConfirm: () => void;
    selectedConfig: any;
}

const AssignConfigDialog = (props: AssignConfigDialogProps) => {
    const {assignConfigOpen, assignedConfig, handleAssignConfigClose, handleAssignConfigConfirm, selectedConfig} = props;

    const element = (
        <div style={{padding: "10px"}} className="routerConfigDialogsContent">
            <div className="assignConfigBox">
                <span className="routerConfigDialogTextLaligned">Configuration</span>
                <div style={{padding: "0px 12px"}}>
                    <div>
                        <span className="routerConfigDialogTextLaligned">Config Name</span>
                        <span className="marginLeft8">{selectedConfig?.nickname ?? "--"}</span>
                    </div>
                    <div>
                        <span className="routerConfigDialogTextLaligned">Config ID</span>
                        <span className="marginLeft8">{selectedConfig?.configId}</span>
                    </div>
                </div>
            </div>
            <div className="routerConfigDialogTextLaligned">This will apply the choosen configuration to the router.</div>
        </div>
    )
    return(
        <CommonModal
            open={assignConfigOpen && !assignedConfig}
            onClose={handleAssignConfigClose}
            onSave={handleAssignConfigConfirm}
            title={"Assign Config"}
            saveText={"Assign"}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"458px"}
            height={"234px"}
            titleWithCustomIcon={true}
            customIcon={alert_icon}
        />
    )
}

export default AssignConfigDialog;